var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#004BA5",
    stroke: "#004BA5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2875 11.775C16.8908 9.61875 15.1233 8 13 8C11.3142 8 9.85 9.025 9.12083 10.525C7.365 10.725 6 12.3187 6 14.25C6 16.3188 7.56917 18 9.5 18H17.0833C18.6933 18 20 16.6 20 14.875C20 13.225 18.8042 11.8875 17.2875 11.775ZM15.9167 13.625L13 16.75L10.0833 13.625H11.8333V11.125H14.1667V13.625H15.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d64b65adc1cab7ab00d8ed188a0a3fda.svg";
export { ForwardRef as ReactComponent };